export default [
        {
            path: '/party_management',          //首页
            component: (resolve) => require(['@/views/party_management/party_management_home'], resolve),
            hidden: true,
            meta: {
                title: '首页',
                code:'party_management',
            },
            children: [
                {
                    path: '/',        //党员管理
                    component: resolve => require(['@/views/party_management/party_member_management'], resolve),
                    meta: {
                      title: '党员管理',
                      code:'party_member_management',
                    }
                },
                {
                    path: 'party_member_management',        //党员管理
                    component: resolve => require(['@/views/party_management/party_member_management'], resolve),
                    meta: {
                      title: '党员管理',
                      code:'party_member_management',
                    }
                },
                {
                    path: 'party_organization_management',        //党组织管理
                    component: resolve => require(['@/views/party_management/party_organization_management'], resolve),
                    meta: {
                      title: '党组织管理',
                      code:'party_organization_management',
                    }
                },
                {
                    path: 'party_member_type',        //党员类型
                    component: resolve => require(['@/views/party_management/party_member_type'], resolve),
                    meta: {
                      title: '党员类型',
                      code:'party_member_type',
                    }
                },
                {
                    path: 'party_organization_type',        //党组织类型
                    component: resolve => require(['@/views/party_management/party_organization_type'], resolve),
                    meta: {
                      title: '党组织类型',
                      code:'party_organization_type',
                    }
                },
            ]
        }
    ]


// WEBPACK FOOTER //
// ./src/router/module/party_management.js